import type React from 'react';

import type { IconProps } from '../types';

export const ArrowLeftXs: React.FC<IconProps> = ({ color = 'currentColor', ...props }) => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.00003 13.3083C7.71065 13.5672 7.27595 13.5606 6.99515 13.3044L2.69144 8.4997C2.44069 8.21947 2.44062 7.78002 2.69144 7.4997L6.94144 2.7497C7.21765 2.44112 7.69138 2.41494 8.00003 2.69111C8.30861 2.96732 8.33479 3.44105 8.05862 3.7497L4.92776 7.2497L12.75 7.2497C13.1642 7.2497 13.5 7.58549 13.5 7.9997C13.5 8.41391 13.1642 8.7497 12.75 8.7497L4.92776 8.7497L8.10745 12.3093C8.33091 12.6167 8.2893 13.0494 8.00003 13.3083Z"
      fill={color}
    />
  </svg>
);
